"use client";
import { Container, Skeleton, createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  landing: {
    paddingBottom: "60px",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundImage: `url(/images/landing_background.png)`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      backgroundPositionX: "left",
      opacity: 0.15,
    },
    height: "67vh",
  },
  shadow: {
    background: "#FFFFFF",
    boxShadow: "0px 1px 10px rgba(0, 0, 0, 0.1)",
    borderRadius: "12px",
    padding: "16px",
  },
  WH: {
    width: "204px",
    height: "90px",
  },
  WH2: {
    width: "220px",
    height: "127px",
    marginTop: "20px",
  },

  cavatar: {
    width: "58px",
    height: "58px",
    borderRadius: "12px",
    backgroundColor: theme.colors.primaryOpacity,
    display: "flex",
    justifyContent: "center" /* Centers items horizontally */,
    alignItems: "center",
  },
}));

const LandingSkeleton = () => {
  const { classes } = useStyles();
  return (
    <div className={classes.landing}>
      <Container className='relative flex flex-col  h-[100%]  items-center justify-center '>
        {/* <div className="flex justify-end">
          <div
            className={`${classes.shadow} ${classes.WH} mt-0 lg:mt-[40px] flex items-center justify-between`}
          >
            <div>
              <Skeleton height={58} width={58} />
            </div>
            <div>
              <Skeleton height={22} width={20} />
              <div className="capitalize text-gray-400">
                <Skeleton height={25} width={99} mt={4} />
              </div>
            </div>
          </div>
        </div> */}
        <div className='flex flex-col items-center'>
          <Skeleton height={120} className='w-[540px]' />
          <Skeleton height={74} className='w-[726px] mt-[24px]' />
        </div>
        <div className='flex flex-wrap justify-center mt-[28px]'>
          <Skeleton height={50} width={260} radius='md' m={4} />
          <Skeleton height={50} width={174} radius='md' m={4} />
          <Skeleton height={50} width={173} radius='md' m={4} />
        </div>
        {/* <div className="flex justify-start">
          <div
            className={`${classes.shadow} ${classes.WH2} flex justify-center`}
          >
            <div className="flex flex-col justify-around items-center">
              <Skeleton height={25} width={81} />
              <div className="capitalize text-gray-400">
                <Skeleton height={70} width={152} />
              </div>
            </div>
          </div>
        </div> */}
      </Container>
    </div>
  );
};

export default LandingSkeleton;
